<template>
  <div class="modal-custom ">
    <div class="modal-content bgmorado">
      <div @click="$emit('close')" class="close bold">x</div>
      <h3 class="pt-3 text-center blanco bold">Restablecer contraseña</h3>
      <div v-if="!showSuccess" class="">
        <p class="text-center blanco">
          Ingresa tu correo y si está registrado en el sitio te enviaremos un
          correo de recuperación:
        </p>

        <div class="row">
          <div class="col-md-6 offset-md-3">
            <form @submit="resetPassword($event)">
              <input
                v-model.trim="email"
                type="email"
                placeholder="Correo electrónico"
                class="text-center"
                required
              />

              <button
                type="submit"
                class=" pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
              >
                Restablecer
              </button>
            </form>
          </div>
        </div>
        <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
      </div>
      <p v-else class="text-center ">
        Revisa la bandeja de correo y da click en la liga de recuperación.
      </p>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";

export default {
  data() {
    return {
      email: "",
      showSuccess: false,
      errorMsg: "",
    };
  },
  methods: {
    async resetPassword(e) {
      e.preventDefault();

      this.errorMsg = "";

      try {
        await auth.sendPasswordResetEmail(this.email);
        this.showSuccess = true;
      } catch (err) {
        this.errorMsg = err.message;
      }


    },
  },
};
</script>
